// extracted by mini-css-extract-plugin
export default {"zoomModal":"y4-z"};